
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gamtracker",
      function () {
        return require("private-next-pages/gamtracker/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gamtracker"])
      });
    }
  